import { render, staticRenderFns } from "./ScreenPerfilCervical.vue?vue&type=template&id=ca7256b0&scoped=true&"
import script from "./ScreenPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenPerfilCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPerfilCervical.vue?vue&type=style&index=0&id=ca7256b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7256b0",
  null
  
)

export default component.exports